
export default {
    // English is defined as "root" to be used as fallback
    "root": {
      weekLetter:"W",
      sizeunit:{
        "B":" B",
        "KB":" KB",
        "MB":" MB",
        "GB":" GB",
        "TB":" TB"
      }
    },  
    "fr": {
      weekLetter:"S",
      sizeunit: {
        "B": "o",
        "KB": "Ko",
        "MB": "Mo",
        "GB": "Go",
        "TB": "To"
      }
    },
    "es": {
      weekLetter:"S"
    },
    "de": {},
    "pt": {
      weekLetter:"S"
    },
    "sq": {},
    "nl": {},
    "it":{
      weekLetter:"S"
    },
    "ja":{},
    "ru":{}
    
  }

